import { ValueOf } from '../common/utils';

export const CATEGORY_DEGREE = {
  MAIN: 1,
  SUB: 2,
} as const;
export type CATEGORY_DEGREE = ValueOf<typeof CATEGORY_DEGREE>;
